import React from 'react';
import { graphql } from "gatsby";
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';
import {default as ReactSlider} from "react-slick";
import { BreakPtMobile } from '../../assets/sass/export.module.scss';
import { defaultSettings } from '../slider/sliderSettings';
import StatBlock from './statBlocks/statBlockModule.js';
const brkptMobileInt = parseInt(BreakPtMobile);

const mobileSlider = {
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: false,
  responsive: [
    {
      breakpoint: brkptMobileInt,
    },
    {
      breakpoint: 10000, // a unrealistically big number to cover up greatest screen resolution
      settings: 'unslick'
    }
  ],
  ...defaultSettings
}

/**
 * CMS Component: DatoCmsModuleStat
 * 
 */
const Stats = ({data, className, ...other}) => {   
    let {anchor, border, stats} = data || {};

    return (
        <ModuleWrapper container={false} anchor={anchor} border={border} className={`stats ${className || ''}`} {...other}>
            {
              stats && 
              <>
                <div className="stats--featured">
                  <div className="container">
                    <StatBlock data={stats[0]}/>
                  </div>
                </div>
                <div className="stats--default">
                  <div className="container">
                    <ReactSlider {...mobileSlider}>
                    {
                      stats?.map((stat, i)=>{
                        return(
                          i > 0 && <StatBlock key={i} data={stat}/>
                        )
                      })
                    }
                    </ReactSlider>
                  </div>
                </div>
              </>
            }
        </ModuleWrapper>
    );
};

export default Stats;

export const ModuleStatsModuleFragment = graphql`
fragment ModuleStatsModuleFragment on DatoCmsModuleStat {
   
  anchor
  border
  stats{
    ...StatsFragment
  }
}
`;

export const  StatsFragment = graphql`
fragment StatsFragment on DatoCmsComponentStat {
  stat
  label
  subHeading
}
`;